import { Component, ViewChild, ElementRef, OnDestroy, Output, EventEmitter } from '@angular/core';
@Component({
    selector: 'picture-loader',
    templateUrl: './picture-loader.component.html',
    styleUrls: ['./picture-loader.component.scss'],
    standalone: false
})
export class PictureLoaderComponent implements OnDestroy {
    @ViewChild("video")
    public video: ElementRef;

    @ViewChild("canvas", { static: true })
    public canvas: ElementRef;

    @Output() public pictureLoaded: EventEmitter<{ base64string: string }> = new EventEmitter<{ base64string: string }>();

    public base64img: string;
    public cameraActive: boolean;
    public currentTrack: MediaStreamTrack;
    public errorMessage: string;

    private maxImgWidth: number = 1000;
    private maxImgHeight: number = 1000;

    public constructor() {
    }

    public activateCamera() {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia({ video: true, audio: false })
            .then(stream => {
                    this.base64img = "";
                    this.cameraActive = true;
                    this.video.nativeElement.srcObject = stream;
                    this.video.nativeElement.play();
                    this.currentTrack = stream.getTracks()[0];
                },
                e => {
                    this.errorMessage = e.message;
                    this.cameraActive = false;
                });
        }
    }

    public capture() {
        this.resizeAndLoad(this.video.nativeElement, this.getResizedImageParams(this.video.nativeElement.videoWidth, this.video.nativeElement.videoHeight));
    }

    public onFileChange(files: any) {
        var reader = new FileReader();

        const file : File = files[0];        

        reader.onloadend = (e: any) => {            
            
            var img = document.createElement("img");

            img.onload = () => {
                this.resizeAndLoad(img, this.getResizedImageParams(img.width, img.height), file.type);
            }
            
            img.src = e.target.result;            
        };

        reader.readAsDataURL(file);
    }

    public ngOnDestroy() {
        this.destroyTrack();
    }

    private resizeAndLoad(element: any, imageSizeParams: number[], mimeType?:string) {       
        var context = this.canvas.nativeElement.getContext("2d");

        this.canvas.nativeElement.width = imageSizeParams[0];
        this.canvas.nativeElement.height = imageSizeParams[1];

        context.drawImage(element, 0, 0, ...imageSizeParams);

        this.base64img = this.canvas.nativeElement.toDataURL(mimeType || "image/jpeg", 1.0);
        this.disableCamera();

        context.clearRect(0, 0, ...imageSizeParams);
        this.errorMessage = "";
        this.emitPictureLoaded();
    }

    private emitPictureLoaded() {
        this.pictureLoaded.emit({ base64string: this.base64img });
    }

    private getResizedImageParams(width: number, height: number): number[] {
        if (width > this.maxImgWidth) {
            height = this.maxImgWidth / (width / height);
            width = this.maxImgWidth;
        }

        if (height > this.maxImgHeight) {
            width = this.maxImgHeight / (height / width);
            height = this.maxImgHeight;
        }

        return [width, height];
    }

    private disableCamera() {
        this.cameraActive = false;

        this.destroyTrack();
    }

    private destroyTrack() {
        if (this.currentTrack) {
            this.currentTrack.stop();
        }
    }
}
